import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { ContentContainer } from 'src/components/ContentContainer';
import { useExit } from 'src/hooks/useExit';

export function AppointmentTypeNotAvailable() {
    const exit = useExit();

    return (<>
        <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium">
                Appointment type unavailable
            </h1>
            <p>
                Your eligibility could not be verified for this appointment type.
                Only patients within a certain age range, or identified section of our patient base, are currently eligible for this specific appointment type.
            </p>
        </ContentContainer>
        <StickyBottomBar>
            <Button className="w-full"
                color="gray"
                onClick={() => exit()} >
                Exit
            </Button>
        </StickyBottomBar>
    </>
    );
}